module.exports = __webpack_public_path__ + "img/1569423275.51b8fa04.jpg";